// extracted by mini-css-extract-plugin
module.exports = {"fixedButton":"FixedButton_fixedButton__2_mjU"};